import { AppState, useAppContext } from "src/services/context";
import { html } from "htm/preact";
import { render } from "preact";
import LocationPicker from "src/components/location-picker/location-picker";
import OrderMenu from "./components/order-menu/order-menu";
import { effect, useSignal } from "@preact/signals";

/**
 * @typedef ReservationAppProps
 * @prop {import("src/types").Restaurant} initialLocation
 * @param {ReservationAppProps} props
 * @returns {import("preact").VNode}
 */
function OrderApp(props) {
  const state = useAppContext();
  const defaultLocation = useSignal(props.initialLocation);

  effect(() => {
    if (state.selectedRid.value && state.restaurants.value.length > 0) {
      defaultLocation.value = state.restaurants.value.find((r) => {
        return r.acf?.opentable_rid === state.selectedRid.value;
      });
    }
  });

  if (
    state.isFetchingRestaurants.value ||
    state.restaurants.value.length === 0
  ) {
    return html`<div aria-live="polite">
      <mx-spinner></mx-spinner> Loading restaurants...
    </div>`;
  }

  if (!state.selectedRestaurant.value) return null;
  /**
   * @param {string} id
   * @returns {void}
   */
  function handleSelectDefaultLocation(id) {
    state.selectedOrderId.value = id;
    state.isLocationConfirmed.value = true;
  }

  return html`<div class="mx-reservation-form">
    <${LocationPicker}
      action="order"
      isVisible=${!state.isLocationConfirmed.value}
      initialLocation=${defaultLocation}
      onSelect=${handleSelectDefaultLocation}
    />
    <${OrderMenu} isVisible=${state.isLocationConfirmed.value} />
  </div> `;
}

/**
 * @param {ReturnType<import("src/services/state").createAppState>} state
 * @param {import("preact").ContainerNode} target
 */
export function createOrdersApp(state, target) {
  const initialLocation = { ...state.selectedRestaurant.value };

  render(
    html`<${AppState.Provider} value="${state}">
      <${OrderApp} initialLocation=${initialLocation} />
    <//> `,
    target
  );
}
